const applyFancyBox = ($fancy_box) => {
    $fancy_box.fancybox(
        {
            beforeShow : function()
            {
                this.title =  $(this.element).data("caption");
            },
            openEffect: "none",
            closeEffect: "none",
            transitionEffect: "fade",
            groupAll: true,
            arrows: true,
            helpers:
                {
                    overlay:
                        {
                            css: { 'background': 'rgba(236, 236, 236, 0.8)' }
                        }
                }
        });
}

$(document).ready(function()
{

    if ($('.fancybox').length)
    {
        applyFancyBox($(".fancybox"));
    }

});

